const step_containers = document.querySelectorAll(".quiz-content-container");
const quiz_options = document.querySelectorAll(".quiz-question-container .quiz-option");

for (const quiz_option of quiz_options) {
  quiz_option.addEventListener("click", function(e) {
    let sel_value = this.dataset.value;
    let parent_container = this.closest(".quiz-content-container");
    parent_container.dataset.selection = sel_value;
    let current_step_num = parseInt((parent_container).dataset.stepnum);
    let next_step_num = ++current_step_num;

    // Logic
    if(next_step_num === 2) {
      // TODO - if step 1 answer === no, then show alternate results
      if(sel_value === "false") {
        for (const step_container of step_containers) {
          step_container.classList.remove("active");
        }
        document.getElementById("quiz-no-fit").classList.add("active");
        return;
      }
    }

    if(next_step_num === 4) {
      let step5 = document.getElementById("step5");
      step5.dataset.formSelection = sel_value;

      if(sel_value === "single") {
        for (const step_container of step_containers) {
          step_container.classList.remove("active");
        }
        document.querySelector(".quiz-content-container[data-stepnum='3b']").classList.add("active");

        return;
      }
    }

    // Results
    if(next_step_num === 6) {
      let selections = [];
      for (const step_container of step_containers) {
        if(step_container.id !== "quiz-results") {
          selections[step_container.dataset.stepname] = step_container.dataset.selection;
        }
      }
      let selection_html = "<ul>";
      for (const [option, selection] of Object.entries(selections)) {
        selection_html += `<li>${option}: ${selection}</li>`;
      }
      selection_html += "</ul>";
      document.getElementById("quiz-data").innerHTML = selection_html;

      let recommendations = getRecommendations(selections);
      let recommendations_pretty = "";
      let recommendations_list = "<ul>";
      let i = 0;
      let cart_price = 0.00;
      for (const recommendation of recommendations) {
        if(recommendation[0] !== null && recommendation[0] !== "" && recommendation[1] !== null && recommendation[1] !== "") {
          if(recommendation[1].available > 2) {
            recommendations_pretty += `<article class="recommended-item-container recommended-item-product" data-variant-id="${recommendation[1].id}"><a href="/products/${recommendation[0].handle}"><img src="${recommendation[1].image}" alt="${recommendation[0].title} - ${recommendation[1].title}"></a></article>`;
            recommendations_list +=
              `<li class="recommendation-option">
                <input id="${recommendation[1].id}" type="checkbox" value="${recommendation[1].id}" class="product-selector" data-price="${recommendation[1].price}" data-quantity="${recommendation[2].quantity}" checked>
                <label for="${recommendation[1].id}">
                  <i class="checked"></i>
                  <i class="unchecked"></i>
                  <span class="product-title">${recommendation[0].title} - ${recommendation[1].title}</span>
                  <span class="product-price">$${recommendation[1].price}</span>
                </label>
              </li>`;
            cart_price += parseFloat(recommendation[1].price);
            i++;
          }
        }
      }
      recommendations_list += "</ul>";

      if(i > 0) {
        recommendations_pretty += '<div class="recommended-item-container recommended-item-results">';
        recommendations_pretty += `<div class="total-price-container"><span class="price-label">Total Price:</span> <b class="price-currency">$</b><b class="price-amount" id="price-amount">${ cart_price.toFixed(2) }</b></div>`;
        recommendations_pretty += '<div class="cta-container"><button id="add-to-cart-button" class="button primary-cta-button">Add to Cart</button></div>';
        recommendations_pretty += '</div>';
      }

      document.getElementById("product-recommendations-summary").innerHTML = recommendations_pretty;
      document.getElementById("product-recommendations-list").innerHTML = recommendations_list;

      addToCartEvent();
      addProductSelectorEvents();
    }


    for (const step_container of step_containers) {
      step_container.classList.remove("active");
    }
    document.querySelector(`.quiz-content-container[data-stepnum='${ next_step_num }']`).classList.add("active");

    updateURL(null,null,next_step_num);
  })
}

const quiz_back_buttons = document.querySelectorAll(".quiz-content-container .quiz-back-button");
for (const quiz_back_button of quiz_back_buttons) {
  quiz_back_button.addEventListener("click", function(e) {
    if(e.target.classList.contains("quiz-restart-button")) {
      for (const step_container of step_containers) {
        step_container.classList.remove("active");
      }
      document.getElementById("step1").classList.add("active");
    }
    else {
      let parent_container = e.target.closest(".quiz-content-container");
      let current_step_num = parseInt((parent_container).dataset.stepnum);
      let prev_step_num = --current_step_num;

      for (const step_container of step_containers) {
        step_container.classList.remove("active");
      }
      document.getElementById(`step${prev_step_num}`).classList.add("active");
    }
  })
}


/***
* updateURL
*
* Param: name - string (name of new URL key to add)
* Param: value - string (vaue of new URL value to add)
* Param: step_num - integer (number of the target step)
*
* Return: N/A
***/
function updateURL(name, value, step_num) {
  const current_url = location.protocol + '//' + location.host + location.pathname;
  let params = new URLSearchParams(location.search);
  let step = stepParams[step_num];

  params.set('step_num', step_num);
  params.set('step', step)
  let url_params = '?' + params.toString();
  let target_url = location.pathname + url_params;
  window.history.pushState({'step': step},'', target_url);

  // Update GA Tracking
  ga('send', 'pageview', target_url);
}

const stepParams = {
  1: "framing",
  2: "size",
  3: "form",
  4: "open_preference",
  5: "style_preference",
  6: "results"
}

function getRecommendations(selections) {
  let recommendations = [];
  // Bracket
  recommendations.push(recommendBracket(selections));
  // Center Bracket (conditional)
  recommendations.push(recommendCenterBracket(selections));
  // Rod
  recommendations.push(...recommendRod(selections));
  // Holdback
  recommendations.push(recommendHoldback(selections));

  return recommendations.filter((obj) => obj);
}

function recommendBracket(selections) {
  let bracket_recommendation, bracket_modifier, bracket_color;
  let bracket_descriptor = "brackets";
  if(selections.form === "single") {
    bracket_recommendation = "single";
    bracket_modifier = (selections.curtain_thickness === "sheer" ? "5/8 in" : "1 in");
    bracket_color = styles_map[selections.style_preference];
  }
  else {
    let double_styles_map = JSON.parse(JSON.stringify(styles_map));
    double_styles_map["traditional"] = "gold";
    double_styles_map["simple"] = "black";

    bracket_recommendation = "double";
    bracket_modifier = "";
    bracket_color = double_styles_map[selections.style_preference];
  }

  let recommendation = getRecommendedProduct([bracket_descriptor, bracket_recommendation], [bracket_color, bracket_modifier]);
  recommendation.push({"quantity": 1});

  return recommendation;
}

function recommendCenterBracket(selections) {
  let center_bracket_recommendation, center_bracket_modifier, center_bracket_color, center_bracket_descriptor, recommendation;

  if(selections.size === "86-120" || selections.size === "120+") {
    let center_bracket_descriptor = "bracket";

    if(selections.form === "single") {
      center_bracket_recommendation = "single center";
      center_bracket_modifier = (selections.type === "sheer" ? "5/8 in" : "1 in");
      center_bracket_color = styles_map[selections.style_preference];

    }
    else {
      let double_styles_map = JSON.parse(JSON.stringify(styles_map));
      double_styles_map["traditional"] = "gold";
      double_styles_map["simple"] = "black";

      center_bracket_recommendation = "double center";
      center_bracket_modifier = "";
      center_bracket_color = double_styles_map[selections.style_preference];
    }

    recommendation = getRecommendedProduct([center_bracket_descriptor, center_bracket_recommendation], [center_bracket_color, center_bracket_modifier]);
    recommendation.push({"quantity": (selections.size === "120+" ? 2 : 1)})
  }
  else {
    recommendation = null;
  }

  let recommendation_text = `${center_bracket_color} ${center_bracket_modifier} ${center_bracket_recommendation} bracket`;

  return recommendation;
}

function recommendRod(selections) {
  let rod_recommendation, rod_modifier, rod_color;
  let recommendation = [];
  let rod_descriptor = "curtain rod";
  if(selections.form === "single") {

    rod_recommendation = "single";
    rod_modifier = (selections.curtain_thickness === "sheer" ? "5/8\"" : "1\"");
    rod_style = rod_styles_map[selections.style_preference][rod_modifier]["style"];
    rod_color = rod_styles_map[selections.style_preference][rod_modifier]["color"];
    rod_length = rod_styles_map[selections.style_preference][rod_modifier]["sizes"][selections.size] || false;
    //rod_length = (typeof rod_styles_map[selections.style_preference][rod_modifier]["sizes"][selections.size] === 'undefined' ? false : rod_styles_map[selections.style_preference][rod_modifier]["sizes"][selections.size]);

    if(rod_length) {
      let this_recommendation = getRecommendedProduct([rod_descriptor, rod_modifier, rod_style], [rod_color, rod_length]);
      this_recommendation.push({"quantity": 1});
      recommendation.push(this_recommendation);
    }

  }
  else {
    rod_recommendation = "double";

    rod_modifier_sheer = "5/8\"";
    rod_style_sheer = rod_styles_map[selections.style_preference][rod_modifier_sheer]["style"];
    rod_color_sheer = rod_styles_map[selections.style_preference][rod_modifier_sheer]["color"];
    rod_length_sheer = rod_styles_map[selections.style_preference][rod_modifier_sheer]["sizes"][selections.size] || false;

    if(rod_length_sheer) {
      let this_recommendation = getRecommendedProduct([rod_descriptor, rod_modifier_sheer, rod_style_sheer], [rod_color_sheer, rod_length_sheer]);
      this_recommendation.push({"quantity": 1});
      recommendation.push(this_recommendation);
    }

    rod_modifier_thick = "1\"";
    rod_style_thick = rod_styles_map[selections.style_preference][rod_modifier_thick]["style"];
    rod_color_thick = rod_styles_map[selections.style_preference][rod_modifier_thick]["color"];
    rod_length_thick = rod_styles_map[selections.style_preference][rod_modifier_thick]["sizes"][selections.size] || false;

    if(rod_length_thick) {
      let this_recommendation = getRecommendedProduct([rod_descriptor, rod_modifier_thick, rod_style_thick], [rod_color_thick, rod_length_thick]);
      this_recommendation.push({"quantity": 1});
      recommendation.push(this_recommendation);
    }
  }

  let recommendation_text = `${rod_color} ${rod_modifier} rod`;

  return recommendation;
}

function recommendHoldback(selections) {
  let holdback_recommendation, holdback_color, recommendation;
  if(selections.open_preference === "true") {
    let holdback_styles_map = JSON.parse(JSON.stringify(styles_map));
    holdback_styles_map["traditional"] = "black";
    holdback_styles_map["gold"] = "bronze";

    holdback_recommendation = "holdback";
    holdback_color = holdback_styles_map[selections.style_preference] || "bronze";
    recommendation = getRecommendedProduct([holdback_recommendation], [holdback_color]);
    recommendation.push({"quantity": 1});
  }
  else {
    holdback_recommendation = null;
    holdback_color = null;
    recommendation = null;
  }

  let recommendation_text = (holdback_recommendation !== null ? `${holdback_color} ${holdback_recommendation}` : null);

  return recommendation;
}

function getRecommendedProduct(product_details, variant_details) {
  let product_key = searchObjectKeys(products_array, product_details);
  let product_recommendation = products_array[product_key];

  let variant_recommendation;
  if(typeof product_recommendation !== "undefined" && product_recommendation !== null) {
    let variant_key = searchObjectKeys(product_recommendation.variants, variant_details);
    variant_recommendation = product_recommendation.variants[variant_key];
  }
  else {
    variant_recommendation = null;
  }

  return [product_recommendation, variant_recommendation];
}

/***
* searchObjectKeys
*
* Param: haystack - Array (object to search within)
* Param: needles - Array (objects to search for - all required)
*
* Return: Key (object key that matches criteria || null if none found)
***/
function searchObjectKeys(haystack, needles) {
  let keys = Object.keys(haystack);
  let result = keys.filter(key => checkKey(key, needles));

  return result[0] || null;
}

function checkKey(key, needles) {
  return needles.every(isMatch, key);
}

function isMatch(needle) {
  return this.toLowerCase().includes(needle.toLowerCase());
}

const styles_map = {
  "classic": "black",
  "traditional": "bronze",
  "modern": "silver",
  "gold": "gold",
  "simple": "white"
}

const rod_styles_map = {
  "classic": {
    "5/8\"": {
      "style": "chelsea",
      "color": "black",
      "sizes": {
        "0-48": "28\" - 48",
        "49-60": "48\" - 86",
        "61-85": "48\" - 86",
      }
    },
    "1\"": {
      "style": "layla",
      "color": "black",
      "sizes": {
        "0-48": "30\" - 84",
        "49-60": "30\" - 84",
        "61-85": "30\" - 84",
      }
    }
  },
  "modern": {
    "5/8\"": {
      "style": "chelsea",
      "color": "silver",
      "sizes": {
        "0-48": "28\" - 48",
        "49-60": "48\" - 86",
        "61-85": "48\" - 86",
      }
    },
    "1\"": {
      "style": "layla",
      "color": "silver",
      "sizes": {
        "0-48": "30\" - 84",
        "49-60": "30\" - 84",
        "61-85": "30\" - 84",
      }
    }
  },
  "gold": {
    "5/8\"": {
      "style": "chelsea",
      "color": "black",
      "sizes": {
        "0-48": "28\" - 48",
        "49-60": "48\" - 86",
        "61-85": "48\" - 86",
      }
    },
    "1\"": {
      "style": "layla",
      "color": "black",
      "sizes": {
        "0-48": "30\" - 84",
        "49-60": "30\" - 84",
        "61-85": "30\" - 84",
      }
    }
  },
  "simple": {
    "5/8\"": {
      "style": "chelsea",
      "color": "white",
      "sizes": {
        "0-48": "28\" - 48",
        "49-60": "48\" - 86",
        "61-85": "48\" - 86",
      }
    },
    "1\"": {
      "style": "layla",
      "color": "silver",
      "sizes": {
        "0-48": "30\" - 84",
        "49-60": "30\" - 84",
        "61-85": "30\" - 84",
      }
    }
  },
  "traditional": {
    "5/8\"": {
      "style": "beckett",
      "color": "pewter",
      "sizes": {
        "0-48": "28\" - 48",
        "49-60": "48\" - 86",
        "61-85": "48\" - 86",
      }
    },
    "1\"": {
      "style": "riley",
      "color": "brown",
      "sizes": {
        "0-48": "30\" - 84",
        "49-60": "30\" - 84",
        "61-85": "30\" - 84",
      }
    }
  }
}

let options = {
  "framing": [
    "true",
    "false"
  ],
  "size": [
    "0-48",
    "49-60",
    "61-85",
    "86-120",
    "120+"
  ],
  "form": [
    "single",
    "double"
  ],
  "type": [
    "sheer",
    "heavyweight"
  ],
  "open_preference": [
    "true",
    "false"
  ],
  "style_preference": [
    "classic",
    "traditional",
    "modern",
    "gold",
    "simple"
  ]
}

function addProductSelectorEvents() {
  const product_selector_inputs = document.querySelectorAll("#product-recommendations-list .product-selector");
  for (const product_selector_input of product_selector_inputs) {
    product_selector_input.addEventListener("change", function(e) {
      let checked = e.target.checked;
      let variant_id = e.target.value;

      let rec_prod_item = document.querySelector(`#product-recommendations-summary .recommended-item-product[data-variant-id='${variant_id}']`);
      rec_prod_item.style.display = (checked ? "block" : "none");

      let total_price = parseFloat(0.00);

      for (const product_selector_input of product_selector_inputs) {
        if(product_selector_input.checked) {
          total_price += parseFloat(product_selector_input.dataset.price);
        }
      }

      document.getElementById("price-amount").innerHTML = total_price.toFixed(2);

    })
  }
}

function addToCartSubmit() {
  const product_selector_inputs = document.querySelectorAll("#product-recommendations-list .product-selector");
  let items = [];
  let results = [];

  for (const product_selector_input of product_selector_inputs) {

    if(product_selector_input.checked) {
      let variant_id = product_selector_input.value;
      let cur_quantity = 1;
      let item_obj = {quantity: cur_quantity, id: parseInt(getVariantId(variant_id))};
      items.push(item_obj);

    }
  }

  let result = addVariantsToCart(items);
}

function addVariantsToCart(items) {
  const params = {items: items};
  const xhttp = new XMLHttpRequest();
  xhttp.open("POST", "/cart/add.js", true);
  xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
  xhttp.send(JSON.stringify(params));
  xhttp.onreadystatechange = function() {
    let result = 400;
    if (this.readyState == 4 && this.status == 200) {
      result = 200;
      let total_quantity = items.map(getItemsQuantity).reduce(getQuantitySum);

      updateCartQuantity(total_quantity);

      showNextSteps();
    }
    else if (this.readyState == 4 && this.status == 400) {
      if(window.alert("Uh oh! It looks like we're having trouble with that.")) {
        //window.location.href = "/products/single-bracket";
      }
      result = 400;
    }
  };
}

function getItemsQuantity(item) {
  return item.quantity;
}

function getQuantitySum(prev, next) {
  return prev + next;
}

function updateCartQuantity(qty) {
  var cur_qty = parseInt(document.querySelector("#mobile-header .cart-count .beside-svg").innerText.trim().replace("(","").replace(")",""));
  var new_qty = cur_qty + qty;
  document.querySelector(".cart-summary .cart-count").innerText = "Cart (" + new_qty + ")";
  document.querySelector("#mobile-header .cart-count .beside-svg").innerText = "(" + new_qty + ")";
}

function getVariantId(globalId) {
  return atob(globalId).replace("gid://shopify/ProductVariant/","");
}

function showNextSteps() {
  // Show Added to Cart Heading
  document.getElementById("results-heading").classList.add("active");
  // Hide Add to Cart CTA
  document.getElementById("quiz-results").classList.add("next-steps-display");
  //document.querySelector(".recommended-item-results .cta-container").style.display = "none";
  // Show Next Actions
  document.getElementById("quiz-next-steps").classList.add("active");
}

function resetQuiz() {
  // Show step 1
  const step_containers = document.querySelectorAll(".quiz-content-container");
  for (const step_container of step_containers) {
    step_container.classList.remove("active");
  }
  document.querySelector(".quiz-content-container[data-stepnum='1']").classList.add("active");

  // Reset CTAs & Containers
  document.getElementById("add-to-cart-button").classList.remove("disabled");
  document.getElementById("quiz-results").classList.remove("next-steps-display");

  // Update URL
  updateURL(null,null,1);
}

const api_url = "/api/2020-07/graphql.json";
const shop_domain = window.location.hostname == 'gokwikhangbargains.com'
  ? '43043b3baf8a2dba4625f455bf430beb'
  : 'c4e30cf256eb05024814a810c5c36227';

const headers = new Headers({
  "X-Shopify-Storefront-Access-Token": shop_domain,
  "Content-Type": "application/json",
  "Accept": "application/json"
});
const getShopifyProductVariants = async () => {
  const response = await fetch(api_url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({query: query()})
  });
  return await response.json();
}

const query = () => `
  {
    products(first:20) {
      edges {
        node {
          id
          handle
          title
          variants(first: 15){
            edges {
              node {
                id
                priceV2 {
                  amount
                }
                quantityAvailable
                sku
                title
                image {
                  originalSrc
                  src
                  transformedSrc(maxHeight: 400)
                }
              }
            }
          }
        }
      }
    }
  }`;


const products_array = {};

getShopifyProductVariants().then(response => {

  let product_data = response.data.products.edges;
  product_data.forEach(product => {


    let variant_data = product.node.variants.edges;
    let variants_array = {};

    variant_data.forEach(variant => {
      let variant_obj = {
        "id": variant.node.id,
        "price": variant.node.priceV2.amount,
        "sku": variant.node.sku,
        "title": variant.node.title,
        "available": variant.node.quantityAvailable,
        "image": (variant.node.image !== null ? variant.node.image.transformedSrc : '')
      }
      variants_array[variant.node.title] = variant_obj;
    });

    let product_obj = {
      "id": product.node.id,
      "handle": product.node.handle,
      "title": product.node.title,
      "variants": variants_array
    }
    products_array[product.node.title] = product_obj;
  });

});

function addToCartEvent() {
  document.getElementById("add-to-cart-button").addEventListener("click", function(e) {
    e.preventDefault();
    e.target.classList.add("disabled");
    addToCartSubmit();
  });
}

document.getElementById("new-design-button").addEventListener("click",function(e) {
  resetQuiz();
});
document.getElementById("checkout-button").addEventListener("click",function(e) {
  window.location.href = "/checkout";
});
